export const mask = (model: string, varEvent: any) => {
    let 
        text = varEvent.target.value,
        textLength = text.length,
        modelLength = model.length,
        cursor = varEvent.target.selectionStart,
        cursorFixo = false,
        livre = false,
        j = 0
    ;

    text = text.replace(/\D/g,'');
    
    var id = 0;
    if (window.event) id = varEvent.keyCode;
    else if (varEvent.which) id = varEvent.which;

    if (cursor < textLength) cursorFixo = true;

    if(id === 16 || id === 19 || (id >= 33 && id <= 40)) livre = true;

    if (!livre && id !== 8) {
        varEvent.target.value = '';

        for (let i = 0; i < modelLength; i++) {
            if (model.substr(i, 1) === '#') {
                varEvent.target.value += text.substr(j, 1);
                j++;

            } else if (model.substr(i, 1) !== '#') {
                varEvent.target.value += model.substr(i, 1);
            }

            if(id!==8 && !cursorFixo) cursor++;

		 	if((j) === textLength + 1) break;
        }
    }

 	if(cursorFixo && !livre) cursor--;
 	varEvent.target.setSelectionRange(cursor, cursor);
};